import { getObjectValue, getStringValue } from "../commons/storage";
import { setErrorMessage, setSuccessMessage } from "../context";
import { LOGIN_SUCCESS } from "redux/constants";

export const PersistLoggedInUser = (dispatch) => {
  let token = getStringValue("token");
  let tokenValidity = getStringValue("token_validity");

  if (token && tokenValidity) {
    tokenValidity = new Date(tokenValidity);
    let currentDate = new Date();

    if (tokenValidity >= currentDate) {
      let userData = getObjectValue("user_data");
      const data = {
        token: token,
        token_validity: tokenValidity,
        user_data: userData,
      };

      dispatch({ type: LOGIN_SUCCESS, payload: data });
    }
  }
};

export const IsAuthenticated = () => {
  const token = getStringValue("token");

  return token != "" && token != null && token != undefined;
};

export const ShowSuccessMessage = (dispatch, title, content) => {
  setSuccessMessage(dispatch, {
    title: title,
    content: content,
  });

  setTimeout(() => {
    setSuccessMessage(dispatch, null);
  }, 3000);
};

export const ShowErrorMessage = (dispatch, title, content) => {
  setErrorMessage(dispatch, {
    title: title,
    content: content,
  });

  setTimeout(() => {
    setErrorMessage(dispatch, null);
  }, 3000);
};
